export const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_BASE_URL;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const GOOGLE_REDIRECT_URI = import.meta.env.VITE_GOOGLE_REDIRECT_URI;

export const CUSTOM_DASHBOARD_FLAG = import.meta.env.VITE_CUSTOM_DASHBOARD_FLAG === 'true';
export const DATA_MANAGEMENT_FLAG = import.meta.env.VITE_DATA_MANAGEMENT_FLAG === 'true';
export const SAM_CHATBOT_FLAG = import.meta.env.VITE_SAM_CHATBOT_FLAG === 'true';

export const OVERVIEW_SHOW_TALENT_MANAGEMENT_TAB =
  import.meta.env.VITE_OVERVIEW_SHOW_TALENT_MANAGEMENT_TAB === 'true';
export const OVERVIEW_SHOW_TREND_TAB = import.meta.env.VITE_OVERVIEW_SHOW_TREND_TAB === 'true';

export const DISABLE_CUSTOM_DASHBOARDS_INSIGHTS =
  import.meta.env.VITE_DISABLE_CUSTOM_DASHBOARDS_INSIGHTS === 'true';
export const DISABLE_ADD_GRAPH_WITH_AI = import.meta.env.VITE_DISABLE_ADD_GRAPH_WITH_AI === 'true';
export const DISABLE_ADVANCED_ANALYTICS =
  import.meta.env.VITE_DISABLE_ADVANCED_ANALYTICS === 'true';
export const DISABLE_PEOPLEHUB = import.meta.env.VITE_DISABLE_PEOPLEHUB === 'true';
export const DISABLE_ADD_GRAPH_WITH_TEXT =
  import.meta.env.VITE_DISABLE_ADD_GRAPH_WITH_TEXT === 'true';
export const DISABLE_PROFILE_PICTURE = import.meta.env.VITE_DISABLE_PROFILE_PICTURE === 'true';
export const DISABLE_HOME_PAGE_INSIGHTS =
  import.meta.env.VITE_DISABLE_HOME_PAGE_INSIGHTS === 'true';
export const DISABLE_INDEXMW_INSIGHTS = import.meta.env.VITE_DISABLE_INDEXMW_INSIGHTS === 'true';
export const ENABLE_DEBUG_METRICS = import.meta.env.VITE_ENABLE_DEBUG_METRICS === 'true';
export const DISABLE_INDEX_MW = import.meta.env.VITE_DISABLE_INDEX_MW === 'true';
export const MAPPING_FLAG = import.meta.env.VITE_MAPPING_FLAG === 'true';
export const DISABLE_EXCLUSION_RULES_FLAG =
  import.meta.env.VITE_DISABLE_EXCLUSION_RULES_FLAG === 'true';
export const ENABLE_INSIGHTS_PEOPLEHUB = import.meta.env.VITE_ENABLE_INSIGHTS_PEOPLEHUB === 'true';
export const DISABLE_SUPPORT = import.meta.env.VITE_DISABLE_SUPPORT === 'true';
export const DISABLE_LEGAL_HUB_FLAG = import.meta.env.VITE_DISABLE_LEGAL_HUB_FLAG === 'true';
export const DISABLE_REMUNERATION_FLAG = import.meta.env.VITE_DISABLE_REMUNERATION_FLAG === 'true';
export const DISABLE_FORECAST_FLAG = import.meta.env.VITE_DISABLE_FORECAST_FLAG === 'true';
export const PAYROLL_FORECAST_ENABLED = !DISABLE_FORECAST_FLAG;
export const INSIGHTS_CONCURRENCY = Number(import.meta.env.VITE_INSIGHTS_CONCURRENCY) || 2;
